var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"or-separator"},[_c('div',{staticClass:"border-line"}),_c('div',{staticClass:"or-or"},[_vm._v("OR")]),_c('div',{staticClass:"border-line"})])
}]

export { render, staticRenderFns }